import React, { useEffect, useState } from "react";
import Header from "../components/header";
import { API_KEY } from "../utils/constants";
import { contactUsAPI } from "../api/api";
import Loader from "../components/loader";

function ContactUs() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [telegram, setTelegram] = useState("");
  const [email, setEmail] = useState("");
  const [youtube, setYoutube] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getFundData = async () => {
    const formData = new FormData();
    formData.append("__api_key__", API_KEY);

    await contactUsAPI(formData)
      .then((res) => {
        if (res.data.state === "OK") {
          setIsLoading(false);
          setMobileNumber(res.data.data.meta.contact_number);
          setWhatsapp(res.data.data.meta.whatsapp_number);
          setTelegram(res.data.data.meta.telegram_number);
          setEmail(res.data.data.meta.email);
          setYoutube(res.data.data.meta.youtube_link);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getFundData();
  }, []);

  // Extract YouTube Video ID from URL
  const getYouTubeVideoID = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  const videoId = getYouTubeVideoID(youtube);

  return (
    <div className="main-2 bg-4">
      <Header title="Contact Us" isMenu />
      <div className="container mt-5">
        <div className="d-flex align-items-center my-3">
          <img
            src="./images/whatsapp.png"
            style={{ width: 50, height: 50 }}
            alt="whatsapp"
          />
          <div className="ms-3">
            <h6>WhatsApp</h6>
            <h6
              style={{ color: "#6c62ff", cursor: "pointer" }}
              onClick={() => window.open(`https://wa.me/${whatsapp}`, "_blank")}
            >
              {whatsapp}
            </h6>
          </div>
        </div>

        <div className="d-flex align-items-center my-3">
          <img src="./images/mail.png" style={{ width: 50, height: 50 }} alt="mail" />
          <div className="ms-3">
            <h6>Email</h6>
            <h6
              style={{ color: "#6c62ff", cursor: "pointer" }}
              onClick={() => window.open(`mailto:${email}`, "_blank")}
            >
              {email}
            </h6>
          </div>
        </div>

        {/* YouTube Video Player with Enhanced UI */}
        {videoId && (
          <div style={styles.youtubeContainer}>
            <h5 style={styles.youtubeTitle}>
              <img src="./images/youtube.png" alt="YouTube" style={styles.youtubeIcon} />
              Watch on YouTube
            </h5>
            <div style={styles.youtubeVideo}>
              <iframe
                width="100%"
                height="315"
                src={`https://www.youtube.com/embed/${videoId}`}
                title="YouTube Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={styles.iframe}
              ></iframe>
            </div>
          </div>
        )}
      </div>
      <Loader isLoading={isLoading} />

      {/* Adding CSS using a <style> tag inside JSX */}
      <style>
        {`
          .youtube-container {
            max-width: 600px;
            margin: 20px auto;
            padding: 15px;
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
            text-align: center;
          }
          .youtube-title {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
          }
          .youtube-icon {
            width: 25px;
            height: 25px;
            margin-right: 8px;
          }
          .youtube-video {
            overflow: hidden;
            border-radius: 10px;
            position: relative;
          }
          .youtube-video iframe {
            width: 100%;
            height: 315px;
            border-radius: 10px;
          }
        `}
      </style>
    </div>
  );
}

// Inline CSS for styling
const styles = {
  youtubeContainer: {
    width: '100%',
    margin: "50px auto",
    padding: "15px",
    background: "#ffffff",
    borderRadius: "12px",
    textAlign: "center",
  },
  youtubeTitle: {
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "10px",
  },
  youtubeIcon: {
    display: "none",
    width: "25px",
    height: "25px",
    marginRight: "8px",
  },
  youtubeVideo: {
    overflow: "hidden",
    borderRadius: "10px",
    position: "relative",
  },
  iframe: {
    width: "100%",
    height: "230px",
    borderRadius: "10px",
  },
};

export default ContactUs;
